import { render, staticRenderFns } from "./DashboardHeader.vue?vue&type=template&id=6a41a474&"
import script from "./DashboardHeader.vue?vue&type=script&lang=ts&"
export * from "./DashboardHeader.vue?vue&type=script&lang=ts&"
import style0 from "./DashboardHeader.vue?vue&type=style&index=0&id=6a41a474&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports